import { render, staticRenderFns } from "./ReconfigureMailTokenInvalid.vue?vue&type=template&id=25f6d96a&scoped=true&lang=pug&"
import script from "./ReconfigureMailTokenInvalid.vue?vue&type=script&lang=ts&"
export * from "./ReconfigureMailTokenInvalid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f6d96a",
  null
  
)

export default component.exports